/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2022 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2022 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */

export const dragHandlePath =
  'M9.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-5 5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-5 5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z';

export const locationPath =
  'M11.58 11.758a2.177 2.177 0 1 1 0-4.354 2.177 2.177 0 0 1 0 4.354m0-8.758A6.58 6.58 0 0 0 5 9.58C5 15.15 11.58 21 11.58 21s6.582-5.85 6.582-11.42A6.58 6.58 0 0 0 11.58 3';

export const arrowUpPath = 'M-.08 2.96 2.88 0l2.96 2.96H3.39v8.01H2.37V2.96z';

export const rotatePath =
  'M15.8535534,21.2928932 L15.8535534,18.2971068 C12.49774536,17.5550421 10.06304054,16.3583754 8.54943893,14.7071068 C7.03583731,13.0558382 6.23483987,10.72250482 6.1464466,7.7071068 L3.1464466,7.7071068 L7.1464466,2.7071068 L11.1464466,7.7071068 L8.1464466,7.7071068 C8.36229059,10.28804398 9.10584334,12.28695847 10.37710485,13.7038503 C11.64836636,15.1207421 13.4738492,15.9851609 15.8535534,16.2971068 L15.8535534,13.2928932 L20.8535534,17.2928932 L15.8535534,21.2928932 Z';
